/**
 * Canonical public origin used for outbound-shareable links
 * (referral URLs, team invite URLs, marketing snippets).
 *
 * Always the production domain, regardless of which environment the
 * customer is browsing from. Users on preview.emergentagent.com still
 * share links that point at mediaothers.com so their contacts land
 * on the polished production experience.
 *
 * Override in `.env` via REACT_APP_PUBLIC_URL if you need staging.
 * Never used for Stripe/OAuth redirects — those still use
 * `window.location.origin` so the round-trip stays in the same env.
 */
export function publicOrigin() {
  const raw = (process.env.REACT_APP_PUBLIC_URL || "https://mediaothers.com").trim();
  return raw.replace(/\/+$/, "");
}
